var d = { exports: {} };
export {
  d as __module
};
